import React from 'react';
import SidebarHeader from './SidebarHeader';
import './AppShell.scss';

// Wspólny szkielet aplikacji: lewy sidebar + obszar treści.
// Sidebar zawsze zaczyna się nagłówkiem (logo + tytuł + przełącznik języka),
// dalsza zawartość sidebaru przekazywana jest przez prop `sidebar`.
const AppShell = ({ isBusy = false, sidebar, children }) => (
  <div className={`map-layout${isBusy ? ' is-uploading' : ''}`}>
    <aside className="left-sidebar">
      <SidebarHeader />
      {sidebar}
    </aside>
    {children}
  </div>
);

export default AppShell;
